import React from 'react'

function Mistakes() {
    return (
        <div className='mistakes out' id='mistakes id'>
            <p className='header-two'>Common Posture Mistakes</p>
            <p className='paragraph-two'>
                1. Leaning on 1 leg
                <br/>
                2. Standing with a flat back
                <br/>
                3. Not moving enough.
                <br/>
                4. Hunching your shoulders.
                <br/>
                5. Gazing downward for too long.
                <br/>
                6. Obtuse and acute angles.
                <br/>
                7. Using the wrong size keyboard.
                <br/>
                8. Keeping elbows and wrists bent for too long.
                <br/>
                9. Not using your core muscles.
                <br/>
                10. Using your couch for work.
                <br/>
                11. Poking your chin
            </p>
        </div>
    )
}

export default Mistakes
